import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollConceptService } from 'app/core/services/payroll-concept.service';
import { RefreshConceptService } from 'app/core/services/refresh-concept/refresh-concept.service';
import { RefreshService } from 'app/core/services/refresh.service';

@Component({
  selector: 'dialog-delete-payroll-concept',
  templateUrl: './dialog-delete-payroll-concept.component.html',
  styleUrls: ['./dialog-delete-payroll-concept.component.scss']
})
export class DialogDeletePayrollConceptComponent implements OnInit {
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeletePayrollConceptComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private payrollConceptService: PayrollConceptService,
    private refreshConceptService: RefreshConceptService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteCategory() {
    this.isLoading = true;
    this.payrollConceptService.deleteCategory(this.data.id).subscribe({
      next: (res) => {
        this.refreshConceptService.emitRefresh(this.data.index, this.data.type);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }

  deleteCatalog() {
    this.isLoading = true;
    this.payrollConceptService.deleteCatalog(this.data.id).subscribe({
      next: (res) => {
        this.refreshConceptService.emitRefresh(this.data.index, this.data.type);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }
}
